import React, { useState } from "react";
import { useDispatch, useSelector, shallowEqual } from "react-redux";
import {
  setTasksTypeFilter,
  setTasksDueDateFilter,
  setTasksStatusTagFilter
} from "../../../redux/rm-buddies/actions";
import { setErrorToastMessage } from "../../../redux/geofence/actions";
import { Modal, Input, Checkbox } from "semantic-ui-react";
import "./style.less";
import ModifiedCalendar from "../../../common/components/ModifiedCalendar";

// Keys are same as sent by server
const tasksTypeFilterMap = {
  DELIVERY: "Delivery",
  PICKUP: "Pickup",
  REPAIR: "Repair",
  REPLACEMENT: "Replacement"
};

function RMBuddyTasksFilter({ onApply }) {
  const tasksTypeFilter = useSelector(
    ({ rmBuddies }) => rmBuddies.tasksTypeFilter || [],
    shallowEqual
  );
  const tasksStatusTagFilter = useSelector(
    ({ rmBuddies }) => rmBuddies.tasksStatusTagFilter || [],
    shallowEqual
  );

  const tasksDueDateFilter = useSelector(
    ({ rmBuddies }) => rmBuddies.tasksDueDateFilter
  );

  const [tasksTypeFilterState, setTasksTypeFilterState] = useState(
    tasksTypeFilter
  );
  const [tasksStatusTagFilterState, setTasksStatusTagFilterState] = useState(
    tasksStatusTagFilter
  );
  const dispatch = useDispatch();

  const toggleFilter = type => {
    if (tasksTypeFilterState.indexOf(type) === -1) {
      setTasksTypeFilterState([...tasksTypeFilterState, type]);
    } else {
      setTasksTypeFilterState(tasksTypeFilterState.filter(e => e !== type));
    }
  };

  const toggleStatusTagFilter = type => {
    if (tasksStatusTagFilterState.indexOf(type) === -1) {
      setTasksStatusTagFilterState([...tasksStatusTagFilterState, type]);
    } else {
      setTasksStatusTagFilterState(
        tasksStatusTagFilterState.filter(e => e !== type)
      );
    }
  };

  const [selectedOption, setSelectedOption] = useState(false);
  const [fromDate, setFromDate] = useState(tasksDueDateFilter.fromDate);
  const [toDate, setToDate] = useState(tasksDueDateFilter.toDate);

  const doneHandler = () => {
    if (fromDate > toDate) {
      dispatch(
        setErrorToastMessage(
          "Tasks Filter: From Date must be less than To date !"
        )
      );
      return;
    }
    if (fromDate && toDate) {
      dispatch(
        setTasksDueDateFilter({
          fromDate,
          toDate
        })
      );
    }
    dispatch(setTasksTypeFilter(tasksTypeFilterState));
    dispatch(setTasksStatusTagFilter(tasksStatusTagFilterState));
    if (onApply) {
      onApply();
    }
  };

  const selectDateHandler = value => {
    if (selectedOption === "fromDate") {
      setFromDate(value.endOf("day"));
    }
    if (selectedOption === "toDate") {
      setToDate(value.endOf("day"));
    }
    setSelectedOption(false);
  };

  return (
    <div className="RMBuddyTasksFilter">
      <div className="RMBuddyTasksFilter-filter">
        <h4>BY DATE</h4>
        <div className="RMBuddyTasksFilter-filter-date">
          <div className="RMBuddyTasksFilter-filter-dateSub">
            <Input
              value={fromDate && fromDate.format("YYYY-MM-DD")}
              placeholder="From"
              onClick={() => setSelectedOption("fromDate")}
              icon="calendar alternate outline"
            />
          </div>
          <div className="RMBuddyTasksFilter-filter-dateSub">
            <Input
              value={toDate && toDate.format("YYYY-MM-DD")}
              placeholder="To"
              onClick={() => setSelectedOption("toDate")}
              icon="calendar alternate outline"
            />
          </div>
        </div>
        <h4>BY TASK TYPE</h4>
        <div className="RMBuddyTasksFilter-filter-checkbox">
          {Object.keys(tasksTypeFilterMap).map(key => (
            <React.Fragment>
              <Checkbox
                checked={tasksTypeFilterState.indexOf(key) !== -1}
                onChange={() => toggleFilter(key)}
                label={tasksTypeFilterMap[key]}
              />
            </React.Fragment>
          ))}
        </div>
        <h4>BY TASK STATUS TAG</h4>
        <div className="RMBuddyTasksFilter-filter-checkbox">
          <Checkbox
            checked={tasksStatusTagFilterState.indexOf("PARTIAL_CANCEL") !== -1}
            onChange={() => toggleStatusTagFilter("PARTIAL_CANCEL")}
            label="Partial Cancel"
          />

          <Checkbox
            checked={tasksStatusTagFilterState.indexOf("FULL_CANCEL") !== -1}
            onChange={() => toggleStatusTagFilter("FULL_CANCEL")}
            label="Full Cancel"
          />
        </div>

        <button onClick={doneHandler}>Apply</button>
      </div>
      <Modal
        size="mini"
        className="OverPopup"
        open={selectedOption !== false}
        closeOnEscape={true}
        closeOnDimmerClick={true}
        onClose={() => setSelectedOption(false)}
      >
        <Modal.Content>
          <ModifiedCalendar
            selectRange={false}
            date={
              selectedOption && selectedOption === "fromDate"
                ? fromDate
                : toDate
            }
            onChange={selectDateHandler}
          />
        </Modal.Content>
      </Modal>
    </div>
  );
}

export default RMBuddyTasksFilter;
